Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropdownOption239854235",
  {"root":"DropdownOption239854235--root","highlight":"DropdownOption239854235--highlight","nonHighlight":"DropdownOption239854235--nonHighlight","hoverBackgroundColor":"lightgrey","selectedBackgroundColor":"grey","selectedHoverBackgroundColor":"dimgrey","disabledBackgroundColor":"white"},
  "",
  1,
  "DropdownOption239854235"
);

